/* ============
 * productFlow Transformer
 * ============
 */

import Transformer from './transformer';

export default class ProductFlowOrderTransformer extends Transformer {

  static fetch(order) {
    return {
      id: order.id,
      name: order.name,
    };
  }

  static send(order) {
    return {
      id: order.id,
      name: order.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productFlowOrder.js